import type { Game as GameModel } from '../../services/games';
import type { GameLanguage } from '../../services/gameLanguages';
import type { GameFeatureItem } from './types';

export function formatMaxMultiplier(value: string | null | undefined): string | null {
    const trimmed = value?.trim();
    if (!trimmed) {
        return null;
    }

    if (trimmed.startsWith('×')) {
        return trimmed;
    }

    return `×${trimmed.replace(/^[xX]/, '')}`;
}

export function formatVolatility(value: number | null | undefined): string | null {
    if (value === null || value === undefined) {
        return null;
    }

    return `${value}/5`;
}

export function resolveBannerDescription(gameLanguage: GameLanguage | null): string | null {
    return (
        gameLanguage?.readMoreDescription?.trim() ||
        gameLanguage?.lobbyDescription?.trim() ||
        null
    );
}

export function buildGameFeatureItems(
    game: GameModel,
    gameLanguage: GameLanguage | null
): GameFeatureItem[] {
    return [
        {
            src: game.gameFeatureFirstCardPath,
            text: gameLanguage?.gameFeatures1?.trim() || null,
            title: gameLanguage?.gameFeatures1Title?.trim() || null,
        },
        {
            src: game.gameFeatureSecondCardPath,
            text: gameLanguage?.gameFeatures2?.trim() || null,
            title: gameLanguage?.gameFeatures2Title?.trim() || null,
            featured: true,
        },
        {
            src: game.gameFeatureThirdCardPath,
            text: gameLanguage?.gameFeatures3?.trim() || null,
            title: gameLanguage?.gameFeatures3Title?.trim() || null,
        },
    ].filter((feature): feature is GameFeatureItem => Boolean(feature.src));
}
